import { useRemindersStore } from '@/stores/reminders.js'
import { getFreshAccess } from '@/services/getFreshAccess.js'

function buildWsUrl(base) {
  try {
    let url
    if (/^wss?:\/\//i.test(base)) {
      url = new URL(base)
    } else if (/^https?:\/\//i.test(base)) {
      const u = new URL(base)
      u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:'
      url = u
    } else {
      const loc = window.location
      const protocol = loc.protocol === 'https:' ? 'wss:' : 'ws:'
      const host = loc.host
      const path = base.startsWith('/') ? base : `/${base}`
      url = new URL(`${protocol}//${host}${path}`)
    }
    return url.toString()
  } catch (_) {
    return null
  }
}

class WsRemindersService {
  ws = null
  reconnectTimer = null
  attempts = 0

  async connect() {
    // Если есть старое подключение, закрываем его перед созданием нового
    if (this.ws) {
      if (this.ws.readyState === WebSocket.CONNECTING || this.ws.readyState === WebSocket.OPEN) {
        // Отключаем обработчики, чтобы не запускать переподключение
        this.ws.onclose = null
        this.ws.onerror = null
        try { this.ws.close() } catch {}
      }
      this.ws = null
    }

    const base = import.meta.env.VITE_WS_REMINDERS_URL || '/ws/reminders/'
    const fullUrl = buildWsUrl(base)
    if (!fullUrl) return

    try {
      this.ws = new WebSocket(fullUrl)
      this.ws.onopen = async () => {
        const token = await getFreshAccess({ minTtlSec: 30 })
        this.ws.send(JSON.stringify({ type: 'authenticate', token }))
        this.attempts = 0
      }
      this.ws.onmessage = (e) => {
        try {
          const payload = JSON.parse(e.data)
          // Передаем событие в store (store сам решит показывать ли toast)
          useRemindersStore().applyWsEvent(payload)
        } catch (error) {
        }
      }
      this.ws.onerror = () => {
        // WebSocket автоматически вызовет onclose, не пытаемся закрывать вручную
      }
      this.ws.onclose = (ev) => {
        if (ev.code === 1000) return
        if (this.reconnectTimer) clearTimeout(this.reconnectTimer)
        const delay = Math.min(30000, 1000 * Math.pow(2, this.attempts++))
        this.reconnectTimer = setTimeout(() => this.connect(), delay)
      }
    } catch {
      const delay = Math.min(30000, 1000 * Math.pow(2, this.attempts++))
      this.reconnectTimer = setTimeout(() => this.connect(), delay)
    }
  }

  close() {
    if (this.reconnectTimer) clearTimeout(this.reconnectTimer)
    // Проверяем readyState перед закрытием
    if (this.ws && this.ws.readyState <= WebSocket.OPEN) {
      try { this.ws.close(1000, 'manual close') } catch {}
    }
    this.ws = null
  }
}

export const wsReminders = new WsRemindersService()
